<template>
  <div
    class="article-simple-card-component app-flex-row"
    :class="[`size-${size}`, `theme-${theme}`]"
  >
    <div class="image-wrapper">
      <img
        v-lazy="item.thumbnail"
        class="thumbnail"
        :alt="`微博营销 ${item.title}`"
        :title="`微博营销 ${item.title}`"
      />
    </div>
    <div class="info app-flex-rest app-flex-column-space-between">
      <span class="title" :class="size === 'small' ? 'font-16' : 'font-18'">
        {{ item.title }}
      </span>
      <span class="author font-14">作者：{{ item.author }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    size: {
      /**
       * 大小：
       * normal：
       * width：379px height：168px
       * info:  padding: 24px 20px 24px;
       * author: font-size:14px; margin-bottom:12px
       * title: font-size:18px

       * small:
       * width：215px height:128px
       * info: padding: 8px 16px;
       * author: font-size:14px;
       * title: font-size:16px
       */
      validator(value) {
        return ['small', 'normal'].includes(value)
      },
      default: 'normal'
    },
    theme: {
      validator(value) {
        return ['light', 'normal'].includes(value)
      },
      default: 'normal'
    }
  }
}
</script>

<style lang="scss" scoped>
/** 宽：379px 高：168px */
.article-simple-card-component {
  width: 379px;
  height: 168px;
  border-radius: 3px;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 24px;
  .image-wrapper {
    width: 168px;
    height: 168px;
    overflow: hidden;
    .thumbnail {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s;
    }
  }

  .info {
    border: 1px solid $neutral-color-3;
    border-left: none;
    padding: 24px 20px 24px;
    background-color: $neutral-color-1;
    height: 100%;
    .title {
      @include text-over-flow(3);
      margin-bottom: 20px;
      word-break: break-all;
      font-weight: bold;
    }
  }

  &.size-small {
    width: 343px;
    height: 128px;
    .image-wrapper {
      width: 128px;
      height: 128px;
    }
    .info {
      border: none;
      padding: 8px 16px;
      background-color: $white;
      .title {
        margin-bottom: 0;
      }
    }
  }
  &.theme-normal:hover {
    /**
    图片整体放大5%,底色色值#ffffff
     */
    .image-wrapper .thumbnail {
      transform: scale(1.05);
    }
    .info {
      background-color: $white;
    }
  }
  &.theme-light:hover {
    .info {
      background-color: $neutral-color-1;
      .title {
        color: $base-color-1;
      }
    }
  }
}
</style>
